/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Header
import Header from '../header';

function Hero(props) {
    return (
        <div className='home-hero'>
            <Header />
            <div className="content max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5 pt-40">
                <h1 className="text-gray-200 text-5xl text-center font-semibold mb-12">{props.title}</h1>
            </div>
        </div>
    )
}

export default Hero